module.exports = __webpack_public_path__ + "static/media/consulting_about_7.4b09a31b.webp";